import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import LoginApi from '@/api/auth-api'
import statsApi from '@/api/statistics-api'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authenticated: false,
    loading: false,
    accessToken: null,
    loginError: false,
    promoEnabled: process.env.VUE_APP_ALLOW_PROMOTIONCODE === 'true',
    giftCardEnabled: process.env.VUE_APP_ALLOW_GIFTCARDS === 'true',
    user: {
      id: null,
      name: null,
      per: null,
      sta: null,
      red: null,
    },
    statistics: [],
  },
  getters: {
    loading: state => state.loading,
    loginError: state => state.loginError,
    authenticated: state => state.authenticated,
    elevated: state =>
      state.authenticated && state.user.per == 'BackOfficeAdministrator',
    supervisor: state =>
      state.authenticated &&
      (state.user.per == 'BackOfficeSupervisor' ||
        state.user.per == 'BackOfficeAdministrator'),
    userName: state => state.user.name,
    token: state => state.accessToken,
    promoEnabled: state => state.promoEnabled,
    giftCardsEnabled: state => state.giftCardEnabled,
    stats: state => state.statistics,
    showStatistics: state =>
      state.user && state.user.sta && state.user.sta != 'No',
    onlyStatistics: state =>
      state.user && state.user.sta && state.user.sta == 'Only',
    isEditor: state =>
      (state.user && state.user.red && state.user.red != 'No') ||
      (state.user && state.user.per == 'BackOfficeAdministrator'),
  },
  mutations: {
    ACCESS_TOKEN_UPDATED: (state, token) => {
      state.accessToken = token
      const jwt = LoginApi.parseJwt(token.token)
      state.user.id = jwt.id
      state.user.name = jwt.sub
      state.user.per = jwt.per
      state.user.sta = jwt.sta
      state.user.red = jwt.red
      if (!state.authenticated) {
        state.authenticated = true
      }
    },
    SITE_DISABLED: state => {
      state.loading = true
    },
    SITE_ENABLED: state => {
      state.loading = false
    },
    LOGIN_ERROR: state => {
      state.loginError = true
    },
    ACCESS_TOKEN_DELETED: state => {
      state.accessToken = null
      state.authenticated = false
      state.user.id = null
      state.user.name = null
      state.user.per = null
    },
    STATISTIC_DEFINITIONS_RECEIVED: (state, stats) => {
      state.statistics = stats
    },
  },
  actions: {
    loadAccesTokens: ({commit}) => {
      const storageToken = localStorage.getItem('accessToken')
      if (storageToken) {
        const token = JSON.parse(storageToken)
        if (new Date(token.expiry) > new Date()) {
          commit('ACCESS_TOKEN_UPDATED', JSON.parse(storageToken))
        }
      }
    },
    refreshStatistics: async ({commit}) => {
      try {
        let data = await statsApi.getAvailableStatistics()
        commit('STATISTIC_DEFINITIONS_RECEIVED', data)
      } catch {
        commit('STATISTIC_DEFINITIONS_RECEIVED', [])
      }
    },
    refreshToken: async ({commit}) => {
      let res = await LoginApi.refresh(commit.token)
      if (res && res.accessToken) {
        var expiresOn = new Date()
        let expiry = expiresOn.setSeconds(
          expiresOn.getSeconds() + res.accessToken.expiresIn,
        )
        res.accessToken.expiry = expiry
        localStorage.setItem('accessToken', JSON.stringify(res.accessToken))
        commit('ACCESS_TOKEN_UPDATED', res.accessToken)
      }
    },
    login: async ({commit}, payload) => {
      commit('SITE_DISABLED')
      try {
        let res = await LoginApi.login(payload.usr, payload.pwd)
        if (res && res.accessToken) {
          var expiresOn = new Date()
          const expiry = expiresOn.setSeconds(
            expiresOn.getSeconds() + res.accessToken.expiresIn,
          )
          res.accessToken.expiry = expiry
          localStorage.setItem('accessToken', JSON.stringify(res.accessToken))
          commit('ACCESS_TOKEN_UPDATED', res.accessToken)
          router.push('/')
        }
      } catch {
        commit('LOGIN_ERROR')
      }

      commit('SITE_ENABLED')
    },
    logout: async ({commit}) => {
      commit('ACCESS_TOKEN_DELETED')
      localStorage.removeItem('accessToken')
      router.push('/login')
    },
  },
})
